import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms"

export class RegexValidator {
    static createValidator(pattern: RegExp | string, errorMessage: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            const regexp = new RegExp(pattern)
            if (regexp.test(control.value) || control.value === '') {
                return null
            } else {
                return {regexError: true, message: errorMessage}
            }
        };
    }
}
